import { WIDGET_DATA_ATTR } from "@constants";

type Output = Record<string, any | General>;

const getWidgetData = (element: HTMLElement): Output => {
  const widgetsConfig = window.WIDGETS_CONFIG;

  if (!widgetsConfig) throw new Error("Config was not provided");

  const widgetId = element.dataset?.[WIDGET_DATA_ATTR];

  if (!widgetId) return null;

  const widgetData = widgetsConfig[widgetId];

  if (!widgetData) throw new Error(`Data for widget "${widgetId}" was not provided`);

  return widgetData;
};

export default getWidgetData;
